import { Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { UserVO } from '../../vo/user/user.vo';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'user-app-link-renderer',
  template: `<wiz-hgroup height="100%" width="100%" gap=5 horizontalAlign="center" verticalAlign="center">
              <wiz-icon *ngIf="isLinked">validate</wiz-icon>
            </wiz-hgroup>
            `,
  styles: [':host {height:100%; width: 100%;}'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserAppLinkRenderer implements AgRendererComponent {

  data: UserVO;
  params: any;

  constructor(private elementRef: ElementRef, private cdref: ChangeDetectorRef) { }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.data = params.data;
    this.params = params;
    this.cdref.markForCheck();
  }

  get isLinked(): boolean {
    return this.params.isUserLinked(this.data);
  }

}
